<div class="flex-row flex-justify-end flex-align-end">
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="gb-event-ticket-dialog">
  <div class="ticket" *ngIf="{ eventTicket: selectedEventTicket$ | async, auction: auction$ | async } as obs">
    <div class="ticket-header flex-row flex-justify-space-between">
      <img
        [s3File]="
          isLightPrimaryColor(obs.auction?.primary_color)
            ? 'galabid_default_logo_black.png'
            : 'galabid_default_logo_white.png'
        "
        class="logo"
      />
      <div class="header-datetime flex-col flex-justify-end flex-align-end">
        <p class="ticket-hour">
          {{ getEventHour(obs.auction?.event_dates, obs.auction?.timezone) }}
        </p>
        <p class="ticket-date">
          {{ getEventDate(obs.auction?.event_dates, obs.auction?.timezone) }}
        </p>
      </div>
    </div>
    <div class="primary-field flex-col flex-justify-start flex-align-start">
      <div class="primary-field-container">
        <p class="event-name ticket-field-primary gb-two-line-truncate">{{ obs.auction?.event_name }}</p>
      </div>
      <div class="primary-field-container">
        <p class="ticket-field-primary gb-two-line-truncate">{{ obs.eventTicket?.ticket_package?.name }}</p>
      </div>
      <div class="primary-field-container">
        <p class="ticket-field-primary-normal gb-two-line-truncate">
          {{ getEventLocation(obs.auction?.event_location) }}
        </p>
        <p
          class="ticket-field-primary-normal gb-two-line-truncate"
          *ngIf="!!getEventLatLong(obs.auction?.event_location)"
        >
          <a
            class="geo-location-link"
            href="https://www.google.com/maps/search/?api=1&query={{ getEventLatLong(obs.auction?.event_location) }}"
            target="_blank"
          >
            <mat-icon>location_on</mat-icon>{{ 'EVENT_TICKET.DIALOG.VIEW_ON_MAP' | translate }}
          </a>
        </p>
      </div>
    </div>

    <div class="secondary-fields flex-col flex-justify-start flex-align-start">
      <div class="ordering-info flex-col flex-justify-left">
        <p
          class="ticket-field-secondary three-line-truncate"
          translate="EVENT_TICKET.DIALOG.ORDER_INFO"
          [translateParams]="{
            purchaser: obs.eventTicket?.purchaser | gbDisplayName,
            purchase_date: (obs.eventTicket?.purchase_date | date: 'EEE, MMMM d, yyyy h:mm a')
          }"
        ></p>
      </div>
      <div class="flex-col flex-justify-left">
        <p class="ticket-label" translate="EVENT_TICKET.DIALOG.GUEST"></p>
        <p class="ticket-field-secondary gb-two-line-truncate">
          {{ obs.eventTicket?.profile | gbDisplayName }}
        </p>
        <p class="ticket-field-secondary gb-two-line-truncate">{{ obs.eventTicket?.profile?.email }}</p>
        <p *ngIf="obs.eventTicket?.profile?.phone_number" class="ticket-field-secondary gb-two-line-truncate">
          {{ obs.eventTicket?.profile?.phone_number }}
        </p>
      </div>
    </div>
    <div class="qr-code flex-col flex-justify-center flex-align-center">
      <img src="{{ obs.eventTicket?.checkin_qrcode }}" />
      <p class="ticket-number">{{ obs.eventTicket?.ticket_number }}</p>
    </div>
  </div>
</mat-dialog-content>
